import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Skeleton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface MyCafeteriaPeriodLabelProps {
  loading: boolean;
  startDate: Date;
  endDate: Date;
}

export const MyCafeteriaPeriodLabel = ({
  loading,
  startDate,
  endDate,
}: MyCafeteriaPeriodLabelProps) => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();

  return (
    <Box>
      <Typography
        id="my-cafeteria-summary-card-period-title"
        variant="body1"
        color={theme.palette.gray80.main}
      >
        {t("OC_PERIOD")}
      </Typography>
      {loading ? (
        <Skeleton variant="text" animation="wave" height={50} width={448} />
      ) : (
        <Typography
          id="my-cafeteria-summary-card-period"
          variant="h4"
          color={theme.palette.gray80.main}
        >
          {startDate.toLocaleDateString(i18n.language)} -{" "}
          {endDate.toLocaleDateString(i18n.language)}
        </Typography>
      )}
    </Box>
  );
};

export default MyCafeteriaPeriodLabel;
